import { escapeHtml } from './escapeHtml';

/**
 * Escapes a string for safe interpolation into a double-quoted HTML attribute.
 * Strips the same characters as {@link escapeHtml} — kept as a separate helper
 * so the call sites are explicit about the context, which matters for review.
 */
export const escapeHtmlAttr = (value: string): string => escapeHtml(value);
